import {
    type ResolveContactFormResponseType,
    type ResolveContactFormRequestType
} from "./type";
import {
    request
} from "../request";

const resolveContactForm = async (
    params: ResolveContactFormRequestType
): Promise<ResolveContactFormResponseType> => {
    return await request<ResolveContactFormResponseType>(`/request/resolveContactForm/${params.id}`, {
        body: JSON.stringify({
            adminNotes: params.adminNotes,
            status: params.status
        }),
        method: "PUT"
    });
};
export default resolveContactForm;
